var map = {
	"./360-factory-visibility.svg": "./src/assets/img/industry-40/thumbnails/360-factory-visibility.svg",
	"./automated-material-flow.svg": "./src/assets/img/industry-40/thumbnails/automated-material-flow.svg",
	"./data-driven-maintenance.svg": "./src/assets/img/industry-40/thumbnails/data-driven-maintenance.svg",
	"./digital-organisation.svg": "./src/assets/img/industry-40/thumbnails/digital-organisation.svg",
	"./digital-ready-infrastructure.svg": "./src/assets/img/industry-40/thumbnails/digital-ready-infrastructure.svg",
	"./factory-of-the-future-leadership-training.svg": "./src/assets/img/industry-40/thumbnails/factory-of-the-future-leadership-training.svg",
	"./intelligent-quality.svg": "./src/assets/img/industry-40/thumbnails/intelligent-quality.svg",
	"./introduction-to-industry-40-training.svg": "./src/assets/img/industry-40/thumbnails/introduction-to-industry-40-training.svg",
	"./sustainability.svg": "./src/assets/img/industry-40/thumbnails/sustainability.svg",
	"./tech-augmented-workforce.svg": "./src/assets/img/industry-40/thumbnails/tech-augmented-workforce.svg",
	"./zero-touches-production.svg": "./src/assets/img/industry-40/thumbnails/zero-touches-production.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/industry-40/thumbnails sync recursive ^\\.\\/.*$";